"use strict";

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetInviteLink = exports.getInviteLink = exports.verifyPinCreateUser = exports.verifyPinStepForm = exports.trackAccessorGetApp = exports.trackAds = exports.resetStaging = exports.stageMessageValues = exports.resetComment = exports.leaveComment = exports.confirmPhone = exports.savePhone = exports.showMoreMessages = exports.resetMessage = exports.leaveMessage = exports.createUser = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.filter.js");

var _index = _interopRequireDefault(require("axios/index"));

var _isEmpty = _interopRequireDefault(require("lodash-es/isEmpty"));

var _transformAxiosError = _interopRequireDefault(require("@evdy/web-etc/dist/lib/transformAxiosError"));

var _actions = require("../webCommunity/actions");

var _constants = require("../../constants");

var _operations = require("../authUser/operations");

var _actions2 = require("../authUser/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var instance = _index.default.create({
  baseURL: "".concat(_constants.API_URL)
}); // Create new user


var createUser = function createUser(_ref) {
  var name = _ref.name,
      email = _ref.email,
      memorialId = _ref.memorialId;
  return function (dispatch) {
    dispatch((0, _actions.leaveCommentRequest)());

    var handleSuccess = function handleSuccess(res) {
      dispatch((0, _actions2.dashLoginSuccess)(res));
      dispatch((0, _actions.setMessageStaging)({
        loginById: false,
        userCreated: true
      }));
    };

    return instance.post("/v2/public/web/notyou", {
      name: name,
      email: email,
      memorialId: memorialId
    }).then(function (res) {
      return handleSuccess(res);
    }, function (err) {
      return dispatch((0, _actions2.dashLoginFailure)((0, _transformAxiosError.default)(err)));
    });
  };
}; // Public login(via SlideOut menu)
// verify pin and step login form, don't create a new user


exports.createUser = createUser;

var verifyPinStepForm = function verifyPinStepForm(_ref2) {
  var pin = _ref2.pin,
      phone = _ref2.phone,
      stepFormFn = _ref2.stepFormFn;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var _yield$dispatch, payload, _ref4, name, email, _ref5, first, last, middle, hasName;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return dispatch((0, _operations.verifyPin)({
                pin: pin,
                phone: phone,
                dontCreate: true
              }));

            case 3:
              _yield$dispatch = _context.sent;
              payload = _yield$dispatch.payload;

              if (payload) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              _ref4 = payload.data || {}, name = _ref4.name, email = _ref4.email;
              _ref5 = name || {}, first = _ref5.first, last = _ref5.last, middle = _ref5.middle;
              hasName = !![first, last, middle].filter(Boolean).length; //if no user name info or email is found send to last form step

              if (!hasName && !email) {
                stepFormFn();
              }

              _context.next = 15;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}; //only create a user after getting name and email
//verify pin to create a new user and put on the user name and email


exports.verifyPinStepForm = verifyPinStepForm;

var verifyPinCreateUser = function verifyPinCreateUser(_ref6) {
  var pin = _ref6.pin,
      phone = _ref6.phone,
      email = _ref6.email,
      name = _ref6.name;
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var _yield$dispatch2, verifyPinPayload;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return dispatch((0, _operations.verifyPin)({
                pin: pin,
                phone: phone
              }));

            case 3:
              _yield$dispatch2 = _context2.sent;
              verifyPinPayload = _yield$dispatch2.payload;

              if (verifyPinPayload) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return");

            case 7:
              _context2.next = 9;
              return dispatch((0, _operations.editUserProfile)({
                phone: phone,
                email: email,
                name: name
              }));

            case 9:
              _context2.next = 13;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }));

    return function (_x2) {
      return _ref7.apply(this, arguments);
    };
  }();
}; // Message


exports.verifyPinCreateUser = verifyPinCreateUser;

var leaveMessage = function leaveMessage(_ref8) {
  var memorialId = _ref8.memorialId,
      name = _ref8.name,
      email = _ref8.email,
      phone = _ref8.phone,
      message = _ref8.message,
      isLoggedIn = _ref8.isLoggedIn;
  return function (dispatch) {
    dispatch((0, _actions.leaveMessageRequest)());
    var body = {
      name: name,
      email: email,
      phone: phone,
      message: message
    };

    var handleAnonSuccess = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref9) {
        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = _ref9.data;
                dispatch((0, _actions.leaveMessageSuccess)({
                  data: data.memorial.condolences
                })); // await logging user first to avoid asking for phone input 2x

                _context3.next = 4;
                return dispatch((0, _actions2.dashLoginSuccess)({
                  data: {
                    data: data.user
                  }
                }));

              case 4:
                _context3.next = 6;
                return dispatch((0, _actions.setMessageStaging)({
                  sentPin: data.sentPin,
                  messageSaved: true
                }));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function handleAnonSuccess(_x3) {
        return _ref10.apply(this, arguments);
      };
    }();

    var handleLoggedSuccess = function handleLoggedSuccess(_ref11) {
      var data = _ref11.data;
      // make this leaveMessageSuccess its own action so you can update the reducer and not have to either replace or concat the condolence
      dispatch((0, _actions.leaveMessageSuccess)({
        data: data
      })); // dispatch staged messaged with sent pin, already logged
      // make sure this needs sentPin true, might not need it

      dispatch((0, _actions.setMessageStaging)({
        messageSaved: true
      }));
    };

    var handleSuccess = function handleSuccess(_ref12) {
      var data = _ref12.data;
      return isLoggedIn ? handleLoggedSuccess({
        data: data
      }) : handleAnonSuccess({
        data: data
      });
    }; // use private ep if logged in


    return instance.post(isLoggedIn ? "/v2/private/memorial/".concat(memorialId, "/condolence") : "/v2/public/memorial/".concat(memorialId, "/condolence"), body).then(function (res) {
      return handleSuccess({
        data: res.data.data
      });
    }, function (err) {
      return dispatch((0, _actions.leaveMessageFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.leaveMessage = leaveMessage;

var resetMessage = function resetMessage() {
  return function (dispatch) {
    return dispatch((0, _actions.resetMessageAction)());
  };
};

exports.resetMessage = resetMessage;

var savePhone = function savePhone(_ref13) {
  var phone = _ref13.phone;
  return function (dispatch) {
    dispatch((0, _operations.saveUserPhone)({
      phone: phone
    }));
  };
};

exports.savePhone = savePhone;

var confirmPhone = function confirmPhone(_ref14) {
  var phone = _ref14.phone,
      pin = _ref14.pin;
  return /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
      var _ref16, error;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return dispatch((0, _operations.verifyPin)({
                phone: phone,
                pin: pin
              }));

            case 3:
              _context4.t0 = _context4.sent;

              if (_context4.t0) {
                _context4.next = 6;
                break;
              }

              _context4.t0 = {};

            case 6:
              _ref16 = _context4.t0;
              error = _ref16.error;
              if ((0, _isEmpty.default)(error)) dispatch((0, _actions.setMessageStaging)({
                verifiedPin: true
              }));
              _context4.next = 13;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t1 = _context4["catch"](0);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 11]]);
    }));

    return function (_x4) {
      return _ref15.apply(this, arguments);
    };
  }();
};

exports.confirmPhone = confirmPhone;

var stageMessageValues = function stageMessageValues(values) {
  return function (dispatch) {
    dispatch((0, _actions.setMessageStaging)(values));
  };
};

exports.stageMessageValues = stageMessageValues;

var resetStaging = function resetStaging() {
  return function (dispatch) {
    dispatch((0, _actions.resetMessageStaging)());
  };
};

exports.resetStaging = resetStaging;

var showMoreMessages = function showMoreMessages(_ref17) {
  var msgIncrementAmount = _ref17.msgIncrementAmount;
  return function (dispatch) {
    dispatch((0, _actions.setShowMoreMessages)(msgIncrementAmount));
  };
}; // Comment


exports.showMoreMessages = showMoreMessages;

var leaveComment = function leaveComment(_ref18) {
  var memorialId = _ref18.memorialId,
      mediaId = _ref18.mediaId,
      message = _ref18.message;
  return function (dispatch) {
    dispatch((0, _actions.leaveCommentRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/condolence/").concat(mediaId, "/comment"), {
      message: message
    }).then(function (res) {
      return dispatch((0, _actions.leaveCommentSuccess)({
        data: res.data.data,
        mediaId: mediaId
      }));
    }, function (err) {
      return dispatch((0, _actions.leaveCommentFailure)({
        error: (0, _transformAxiosError.default)(err)
      }));
    });
  };
};

exports.leaveComment = leaveComment;

var resetComment = function resetComment() {
  return function (dispatch) {
    return dispatch((0, _actions.resetCommentAction)());
  };
}; // Ads


exports.resetComment = resetComment;

var trackAds = function trackAds(_ref19) {
  var memorialId = _ref19.memorialId,
      adId = _ref19.adId;
  return function (dispatch) {
    dispatch((0, _actions.logAdTrackRequest)());
    return instance.post("/v2/private/ads/".concat(adId, "/tapped"), {
      from: 'web',
      memorialId: memorialId
    }).then(function (res) {
      return dispatch((0, _actions.logAdTrackSuccess)());
    }).catch(function (err) {
      return dispatch((0, _actions.logAdTrackFailure)());
    });
  };
}; // Tracking


exports.trackAds = trackAds;

var trackAccessorGetApp = function trackAccessorGetApp(_ref20) {
  var pageName = _ref20.pageName,
      userId = _ref20.userId,
      memorialId = _ref20.memorialId;
  return function (dispatch) {
    dispatch((0, _actions.logAccessorAppTrackingRequest)());
    return instance.post("/v2/public/memorial/".concat(memorialId, "/tracking"), {
      userId: userId,
      pageName: pageName
    }).then(function (res) {
      return dispatch((0, _actions.logAccessorAppTrackingSuccess)(res.data));
    }).catch(function (err) {
      return dispatch((0, _actions.logAccessorAppTrackingFailure)(err));
    });
  };
}; // Invite Link


exports.trackAccessorGetApp = trackAccessorGetApp;

var getInviteLink = function getInviteLink(_ref21) {
  var userId = _ref21.userId,
      email = _ref21.email,
      memorialId = _ref21.memorialId;
  return function (dispatch) {
    dispatch((0, _actions.getInviteLinkRequest)());
    return instance.post("/v2/".concat(userId ? 'private' : 'public', "/user/emailfordesktop"), {
      email: email,
      memorialId: memorialId
    }).then(function (res) {
      return dispatch((0, _actions.getInviteLinkSuccess)(res.data));
    }).catch(function (err) {
      return dispatch((0, _actions.getInviteLinkFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.getInviteLink = getInviteLink;

var resetInviteLink = function resetInviteLink() {
  return function (dispatch) {
    dispatch((0, _actions.resetInviteLinkRequest)());
  };
};

exports.resetInviteLink = resetInviteLink;